import { TextField, Box } from '@mui/material';
import DateRangePicker from '@mui/lab/DateRangePicker';
import AdapterDayjs from '@mui/lab/AdapterDayjs';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import dayjs from 'dayjs';

export function FilterByDate({ datesRange, setDatesRange, setPagination }) {
    const handleValueChange = newRangeOfDates => {
        setDatesRange(newRangeOfDates);
        setPagination({
            page: 0,
            rowsPerPage: 10
        });
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DateRangePicker
                startText="From"
                endText="To"
                sx={{ width: '100%' }}
                maxDate={dayjs().endOf('day')}
                desktopModeMediaQuery="@media only screen and (min-width: 600px) "
                renderInput={(startProps, endProps) => (
                    <Box
                        display="flex"
                        alignItems="center"
                        sx={{ width: '100%', minWidth: '150px' }}
                        className="transactions-search__item">
                        <TextField {...startProps} size="small" sx={{ width: '100%', minWidth: '150px' }} />
                        <Box sx={{ mx: 1 }}> - </Box>
                        <TextField {...endProps} size="small" sx={{ width: '100%', minWidth: '150px' }} />
                    </Box>
                )}
                okText={'Apply'}
                onChange={handleValueChange}
                value={datesRange}
            />
        </LocalizationProvider>
    );
}
